import { callCloudFunction } from "utils/cloudbase"
import { ArticleModel, PageArticleReq } from "./types"

/**
 * 获取文章分页请求
 * @param req 
 */
export const pageArticle = async (req: PageArticleReq): Promise<PageResp<ArticleModel>> => {
    const result = await callCloudFunction({
        action: 'pageArticle',
        data: req
    }) as any

    return result || {
        ...req,
        total: 0,
        list: []
    }
}

/**
 * 获取文章详情
 * @param articleId 
 */
export const detailArticle = async (articleId: string): Promise<CloudBaseResp<ArticleModel>> => {
    const result = await callCloudFunction({
        action: 'detailArticle',
        data: { id: articleId }
    }) as ArticleModel

    return result
}